import React, { ReactNode } from 'react';
import classnames from 'classnames';
import { Button as BootstrapButton } from 'reactstrap';
import './MainButton.scss';

type Props = {
  children?: ReactNode;
  invert?: boolean;
  purple?: boolean;
  red?: boolean;
  green?: boolean;
  lightGreen?: boolean;
  link?: boolean;
  text?: boolean;
  small?: boolean;
  white?: boolean;
  gray?: boolean;
  lightGray?: boolean;
  darkGray?: boolean;
  blue?: boolean;
  className?: string;
  transparent?: boolean;
  extraPadding?: boolean;
  busy?: boolean;
  [key: string]: any;
};

const DeprecatedButton = (props: Props) => {
  const {
    children,
    invert,
    purple,
    blue,
    green,
    gray,
    darkGray,
    lightGray,
    dirtyBlue,
    superDarkGray,
    red,
    link,
    text,
    small,
    white,
    lightGreen,
    extraPadding,
    lightGrayLink,
    className = '',
    transparent,
    busy,
    // tslint:disable-next-line: trailing-comma
    ...rest
  } = props;

  if (busy) rest['disabled'] = true;

  return (
    <BootstrapButton
      {...rest}
      className={classnames('main-button', className, {
        'main-button--invert': invert,
        'main-button--purple': purple,
        'main-button--blue': blue,
        'main-button--dirty-blue': dirtyBlue,
        'main-button--green': green,
        'main-button--gray': gray,
        'main-button--light-gray': lightGray,
        'main-button--dark-gray': darkGray,
        'main-button--dark-gray-invert': invert && darkGray,
        'main-button--link': link,
        'main-button--gray-link': link && gray,
        'main-button--text': text,
        'main-button--white': white,
        'main-button--purple-invert': invert && purple,
        'main-button--blue-invert': invert && blue,
        'main-button--gray-invert': invert && gray,
        'main-button--red': red,
        'main-button--light-green': lightGreen,
        'main-button--light-green-invert': invert && lightGreen,
        'main-button--red-invert': invert && red,
        'main-button--red-invert-transparent': invert && red && transparent,
        'main-button--super-dark-gray': superDarkGray,
        'main-button--super-dark-gray-invert': invert && superDarkGray,
        'main-button--light-gray-link': lightGrayLink,
        'main-button--small': small,
        'main-button--extra-padding': extraPadding,
        'main-button--busy': busy,
      })}
    >
      {busy && (
        <>
          <i className="fas fa-spinner fa-spin" />{' '}
        </>
      )}
      {children}
    </BootstrapButton>
  );
};

export default DeprecatedButton;
